import { useState, useEffect } from "react";
import "./Skills.css";
import SkillItem from "./SkillItem";
import { API } from "../../constant";
import { authFetch } from "../../helpers";
import Loading from "../Hooks/Loading";

const CustomSkills = (Props) => {
    
        const [skillItems, setSkillItems] = useState([]);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);
        let data = Props.skillIds;
        const query = data.map((id, index) => {
            if(index ===0)
            return `filters[id][$in][${index}]=${id}`;
            else
            return `&filters[id][$in][${index}]=${id}`;
        })
      
        useEffect(() => {
            authFetch(`${API}/skills?${query}&populate[0]=Skill_Image&populate[1]=skill_types&populate[2]=users&populate[3]=Complete_Time&populate[4]=completed&populate[5]=triggers`)
              .then((resSkill) => {
                return resSkill.json();
              })
              .then((dataSkills) => {
              
                setSkillItems(dataSkills.data); 
                setLoading(false);
                console.log(dataSkills.data);
              })
              .catch((err) => {
                console.error("Error fetching skills:", err);
                setError("Unable to load skills right now. Please try again.");
                setLoading(false);
              });
          }, []);

          
    if(loading){
        return (<Loading/>)
    }
    if(error){
        return (<div className="skills"><p className="text">{error}</p></div>)
    }
    // console.log(skillItems);
    return(
        <div className="skills">
           
                <div className="skills-inner custom-skills">
                    {skillItems?skillItems.map((item)=>{  
                        return (<SkillItem key={item.id} SklItem={item.attributes} itemId={item.id}/>)              
                    }):()=>{return "There is no item in you favorite list"}}
                </div>
            </div>
    );
}
export default CustomSkills;

